import { Spaceoq5xo9lsieqc as Space } from '../direct/Space.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BlankClass;
function Blank() {
  if (BlankClass === VOID) {
    class $ {
      render_x2fg06_k$(viewWriter, data, index) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Space())(viewWriter.get_context_h02k06_k$());
        ensureOutermostElement(element);
        viewWriter.willAddChild_hz2iwc_k$(element);
        element.onStartup_vrxh3i_k$();
        viewWriter.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
      render_qs4yp2_k$(viewWriter, data, index) {
        return this.render_x2fg06_k$(viewWriter, data, index);
      }
    }
    initMetadataForObject($, 'Blank');
    BlankClass = $;
  }
  return BlankClass;
}
var Blank_instance;
function Blank_getInstance() {
  return Blank_instance;
}
//region block: init
Blank_instance = new (Blank())();
//endregion
//region block: exports
export {
  Blank_instance as Blank_instancesuqgqz38q78o,
};
//endregion

//# sourceMappingURL=RecyclerViewRenderer.mjs.map
